import MainProfile from './MainProfile';

export default MainProfile;
